/*
 * @Author: Vanny
 * @Date: 2019-09-27 14:37:00
 * @LastEditors: Vanny
 * @LastEditTime: 2019-12-12 14:05:28
 * @Description: Excel 处理
 */
import invariant from 'invariant';

import { formatDate } from './date';

/**
 * 导出 Excel 表格
 *
 * @param {array} source 数据列表
 * @param {string} title 导出 Excel 的文件名
 * @param {string} label tab名，默认为文件名
 * @param {function} cb 回调函数
 */
export async function exportToExcel(
  source = [] as string[][],
  title = '未命名',
  label?: string | (() => void),
  cb?: () => void
) {
  const XLSX = await import('xlsx');

  const tabName = typeof label === 'string' ? label : title;
  const ws = XLSX.utils.aoa_to_sheet(source, {});
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, tabName);
  XLSX.writeFile(wb, `${title}${formatDate()}.xlsx`);
  cb && typeof cb === 'function' ? cb() : label && typeof label === 'function' && label();
}
// 读取 XLSX 中的数据
export async function parseExcel(file: File) {
  invariant(file, 'miss file');
  const XLSX = await import('xlsx');

  let resolve: any = null;
  let reject: any = null;
  const p = new Promise((res, rej) => {
    resolve = res;
    reject = rej;
  });
  const reader = new FileReader();

  reader.onload = (e) => {
    try {
      const bstr = (e.target || {}).result;
      const wb = XLSX.read(bstr, { type: 'array' });
      const wsName = wb.SheetNames[0];
      const ws = wb.Sheets[wsName];
      const res: string[][] = XLSX.utils.sheet_to_json(ws, { header: 1 });
      const data = fillExcel(res);
      resolve && resolve(data);
    } catch (error) {
      reject && reject(error);
      throw error;
    }
  };
  reader.readAsArrayBuffer(file);
  const result = await p;
  return result;
}
// 处理从 XLSX 读取到的数据
export function fillExcel(data: string[][], option = { ignoreFirst: true }) {
  try {
    // 忽略第一行
    if (option.ignoreFirst) data.shift();

    if (data.length < 2) return window.alert('请传入有效的数据文件.');

    // 根据第一行补齐其他所有行
    const headerRow = data[0].map((h) => h.toString());
    // 出现空行截断
    let breakLine = 0;
    for (let i = 0; i < data.length; i += 1) {
      let count = 0;
      // 利用forEach 不会遍历 empty 语句
      // eslint-disable-next-line
      data[i].forEach((item, idx) => {
        count += 1;
      });
      breakLine = i;
      if (!count) {
        break;
      }
    }
    data = data.slice(0, breakLine + 1);
    const len = headerRow.length;
    // 迭代 empty语句为 undefined
    data = data.map((row) => {
      row.length = len;
      return headerRow.map((h, idx) => (row[idx] || '').toString() || '');
    });
    return data;
  } catch (error) {
    throw error;
  }
}
